import { NgModule } from '@angular/core';

import { SharedModule } from '@app/shared';
import { ActivityItemComponent } from './activity-item/activity-item.component';
import { EnvironmentActivitiesComponent } from './environment-activities.component';

@NgModule({
    imports: [SharedModule],
    declarations: [
        ActivityItemComponent,
        EnvironmentActivitiesComponent
    ],
    entryComponents: [EnvironmentActivitiesComponent],
    exports: [EnvironmentActivitiesComponent]
})
export class EnvironmentActivitiesModule {
}



// WEBPACK FOOTER //
// ./~/angular2-template-loader!./src/app/authorized/environmentDetails/environment-activities/environment-activities.module.ts